module.exports = __webpack_public_path__ + "media/styles/images/svg/annotation-teal-51fd74cf4d7d6a1c487df11d63355aa0.svg";